// App entry + hash router.
//
// Three views share one page: the record screen (an active sitting), the
// session list, and a session's detail. The record screen self-initializes on
// import and persists for the page lifetime; the router just shows/hides the
// view containers and (re)renders the list/detail on demand.

import "./record";
import { renderSessionList } from "./session-list";
import { renderSessionDetail } from "./session-detail";

const views = {
  record: document.getElementById("view-record") as HTMLElement,
  sessions: document.getElementById("view-sessions") as HTMLElement,
  detail: document.getElementById("view-detail") as HTMLElement,
};
const navLink = document.getElementById("navLink") as HTMLAnchorElement;

type ViewName = keyof typeof views;

function showOnly(name: ViewName) {
  for (const [key, el] of Object.entries(views)) el.hidden = key !== name;
}

/** Parse `#/session/<id>` → { head: "session", id }, tolerating a leading slash. */
function parseHash(): { head: string; id: string } {
  const raw = location.hash.replace(/^#\/?/, "");
  const [head = "", id = ""] = raw.split("/");
  return { head, id: decodeURIComponent(id) };
}

function route() {
  const { head, id } = parseHash();

  if (head === "sessions") {
    showOnly("sessions");
    setNav("New recording", "#/");
    void renderSessionList();
  } else if (head === "session" && id) {
    showOnly("detail");
    setNav("New recording", "#/");
    void renderSessionDetail(id);
  } else {
    showOnly("record");
    setNav("Your sessions", "#/sessions");
  }
  // Each view is its own screen; start it at the top.
  window.scrollTo(0, 0);
}

function setNav(text: string, href: string) {
  navLink.textContent = text;
  navLink.href = href;
}

window.addEventListener("hashchange", route);
route();
